import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Home from "./pages/home-page/Home";
import Necklaces from "./pages/nacklaces-page/Necklaces";
import Navbar from "./components/navbar/Navbar";
import FreeDeliveryBar from "./components/free-delivery-bar/FreeDeliveryBar";
import ProductDetails from "./components/product-details/ProductDetails";
import AntiTarnishJewelleryPage from "./pages/anti-tarnish-jewellery-page/AntiTarnishJewelleryPage";
import { allAntiTarnishJewellery, allKoreanJewellery, allResinJewellery, antiTarnishBracelets, antiTarnishEarrings, antiTarnishJewelleryNecklaces, antiTarnishRings, enamelJewellery, koreanJewelleryEarrings, koreanJewelleryNecklaces, PHONE_NUMBER, resinJewelleryRings, tulipBracelets } from "./constants/ProductConstants";
import ComingSoon from "./components/coming-soon/ComingSoon";
import Footer from "./components/footer/Footer";
import FAQPage from "./pages/faq/FAQPage";
import ContactPage from "./pages/contact-page/ContactPage";
import { NAVBAR_HEIGHT, TOP_BAR_HEIGHT } from "./constants/AppConstants";
import GiftBoxRevealSection from "./components/gift-box/GiftBoxRevealSection";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
}

function App() {
  const [cart, setCart] = useState([]);

  // ✅ ADD TO CART
  const addToCart = (product) => {
    setCart((prev) => {
      const existing = prev.find((p) => p.id === product.id && p.selectedColor === product.selectedColor);

      if (existing) {
        if (existing.quantity >= existing.stock) return prev;

        return prev.map((p) =>
          p.id === product.id && p.selectedColor === product.selectedColor
            ? { ...p, quantity: p.quantity + 1 }
            : p
        );
      }

      const stock = product.colors[product.selectedColorIndex].stock;
      return [...prev, { ...product, quantity: product.quantity || 1, stock }];
    });
  };

  // ✅ INCREASE QTY
  const increaseQty = (item) => {
    setCart((prev) =>
      prev.map((p) =>
        p.id === item.id && p.selectedColor === item.selectedColor && p.quantity < item.stock
          ? { ...p, quantity: p.quantity + 1 }
          : p
      )
    );
  };

  // ✅ DECREASE QTY
  const decreaseQty = (item) => {
    setCart((prev) =>
      prev
        .map((p) =>
          p.id === item.id && p.selectedColor === item.selectedColor ? { ...p, quantity: p.quantity - 1 } : p
        )
        .filter((p) => p.quantity > 0)
    );
  };

  // ✅ WHATSAPP CHECKOUT
  const checkoutWhatsApp = () => {
    const phone = PHONE_NUMBER;

    let message = "Hi, I want to order:\n\n";

    cart.forEach((item) => {
      // determine selected color name (robust for older items)
      const colorFromIndex =
        item.colors && (item.selectedColorIndex || item.selectedColorIndex === 0)
          ? item.colors[item.selectedColorIndex]?.name
          : null;
      const colorLabel = item.selectedColor || colorFromIndex || null;

      message += `${item.name}${colorLabel ? " (" + colorLabel + ")" : ""} x${item.quantity
        } = ₹${item.price * item.quantity}\n`;
    });

    const total = cart.reduce(
      (sum, item) => sum + item.price * item.quantity,
      0
    );

    message += `\nTotal: ₹${total}`;

    window.open(
      `https://wa.me/${phone}?text=${encodeURIComponent(message)}`
    );
  };

  return (
    <BrowserRouter>
      <ScrollToTop />
      <FreeDeliveryBar cart={cart} threshold={499} />
      {/* ✅ GLOBAL NAVBAR */}
      <Navbar
        cart={cart}
        setCart={setCart}
        increaseQty={increaseQty}
        decreaseQty={decreaseQty}
        checkoutWhatsApp={checkoutWhatsApp}
      />

      {/* ✅ ROUTES */}
      <main style={{ marginTop: TOP_BAR_HEIGHT + NAVBAR_HEIGHT }}>
        <Routes>
          <Route path="/" element={<Home addToCart={addToCart} />} />
          <Route path="/necklaces" element={<Necklaces addToCart={addToCart} />} />
          <Route path="/product/:id" element={<ProductDetails addToCart={addToCart} />} />

          {/* 🔜 COMING SOON PAGES */}
          <Route
            path="/anti-tarnish-jewellery/necklaces"
            element={
              <AntiTarnishJewelleryPage
                addToCart={addToCart}
                title="Anti-tarnish Jewellery"
                subtitle="Browse our premium anti-tarnish collection."
                productsList={antiTarnishJewelleryNecklaces}
              />
            } />
          <Route path="/anti-tarnish-jewellery/earrings" element={<AntiTarnishJewelleryPage
            addToCart={addToCart}
            title="Anti-tarnish Earrings"
            subtitle="Browse our premium anti-tarnish collection."
            productsList={antiTarnishEarrings}
          />} />
          <Route path="/anti-tarnish-jewellery/bracelets" element={<AntiTarnishJewelleryPage
            addToCart={addToCart}
            title="Anti-tarnish Bracelets"
            subtitle="Browse our premium anti-tarnish collection."
            productsList={antiTarnishBracelets}
          />} />
          <Route path="/anti-tarnish-jewellery/rings" element={<AntiTarnishJewelleryPage
            addToCart={addToCart}
            title="Anti-tarnish Rings"
            subtitle="Browse our premium anti-tarnish collection."
            productsList={antiTarnishRings}
          />} />
          <Route path="/tulip-bracelets" element={<AntiTarnishJewelleryPage
            addToCart={addToCart}
            title="Tulip Bracelets"
            subtitle="Browse our premium tulip bracelet collection."
            productsList={tulipBracelets}
          />} />
          <Route path="/resin-jewellery/rings" element={<AntiTarnishJewelleryPage
            addToCart={addToCart}
            title="Resin Rings"
            subtitle="Browse our premium resin rings collection."
            productsList={resinJewelleryRings}
          />} />
          <Route path="/korean-jewellery/earrings" element={<AntiTarnishJewelleryPage
            addToCart={addToCart}
            title="Korean Earrings"
            subtitle="Browse our premium Korean earrings collection."
            productsList={koreanJewelleryEarrings}
          />} />
           <Route path="/resin-jewellery/necklaces" element={<ComingSoon title="Resin Necklaces" />} />
           <Route path="/resin-jewellery/earrings" element={<ComingSoon title="Resin Earrings" />} />
          <Route path="/korean-jewellery/necklaces" element={<AntiTarnishJewelleryPage
            addToCart={addToCart}
            title="Korean Necklaces"
            subtitle="Browse our premium Korean necklaces collection."
            productsList={koreanJewelleryNecklaces}
          />} />
          <Route path="/enamel-jewellery" element={<AntiTarnishJewelleryPage
            addToCart={addToCart}
            title="Enamel Necklaces"
            subtitle="Browse our premium Enamel collection."
            productsList={enamelJewellery}
          />} />

          <Route path="/anti-tarnish-jewellery" element={<AntiTarnishJewelleryPage
            addToCart={addToCart}
            title="Anti-tarnish Jewellery"
            subtitle="Browse our premium anti-tarnish collection."
            productsList={allAntiTarnishJewellery}
          />} />
          <Route path="/korean-jewellery" element={<AntiTarnishJewelleryPage
            addToCart={addToCart}
            title="Korean Jewellery"
            subtitle="Browse our premium Korean collection."
            productsList={allKoreanJewellery}
          />} />
          <Route path="/resin-jewellery" element={<AntiTarnishJewelleryPage
            addToCart={addToCart}
            title="Resin Jewellery"
            subtitle="Browse our premium Resin collection."
            productsList={allResinJewellery}
          />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/gift-box" element={<GiftBoxRevealSection />} />
        </Routes>
      </main>
      <Footer />
    </BrowserRouter>
  );
}

export default App;